import { Flex, RiCalendarLine } from "@itandi/itandi-bb-ui";
import type React from "react";
import { Button } from "~/components/common/parts/button/Button";
import { ScheduleInputModal } from "~/components/common/visit_schedule/ScheduleInputModal";
import { useOpenHandler } from "~/hooks/useOpenHandler";
import type { Deal } from "~/models/Deal";
import { isOwnStatus } from "~/models/Status";
import { formatDate } from "~/utils/DateUtil";
import Styles from "./ScheduleInputNavigation.module.scss";

type Props = {
	deal: Deal;
	handleMutate: () => Promise<void>;
};

export const ScheduleInputNavigation: React.FC<Props> = ({
	deal,
	handleMutate
}: Props) => {
	const ownManagement = isOwnStatus(deal.statusId);
	const { isOpen, handleOpen, handleClose } = useOpenHandler();
	return (
		<div className={Styles.NavigationBlock}>
			<div className={Styles.IconWrapper}>
				<RiCalendarLine className={Styles.Icon} />
			</div>
			<div className={Styles.NavigationContent}>
				<div>
					<h4 className={Styles.Title}>
						{ownManagement ? "立会日程・現地調査日程" : "立会日程"}
						を入力してください
						<span className={Styles.OptionalLabel}>任意</span>
					</h4>
					<Flex direction="column" gap={4}>
						{ownManagement || deal.inspectionBy === "company" ? (
							<span>
								{deal.inspectionDate != null
									? `立会日程：${formatDate(deal.inspectionDate, true)}`
									: "登録されていません"}
							</span>
						) : null}
						{ownManagement ? (
							<span>
								{deal.surveyDate != null
									? `現地調査日程：${formatDate(deal.surveyDate, true)}`
									: "登録されていません"}
							</span>
						) : null}
					</Flex>
				</div>
				<div className={Styles.DetailLinkBlock}>
					<Button
						className={Styles.DetailLinkButton}
						onClick={handleOpen}
						variant="normal"
					>
						日程を入力
					</Button>
					{isOpen ? (
						<ScheduleInputModal
							deal={deal}
							handleClose={handleClose}
							handleMutate={handleMutate}
							isOpen={isOpen}
						/>
					) : null}
				</div>
			</div>
		</div>
	);
};
